// Available transmitter type behaviors. Declared like this to allow other modules to iterate over the transmitter types list.
export const TransmitterTypesList = ['default', 'primary', 'secondary'] as const;
export type TransmitterType = typeof TransmitterTypesList[number];
